import { useEffect } from 'react';
import { RU_SITE_URL } from '../../assets/utils/constants';

function Redirect() {
    useEffect(() => {
        window.location.href = RU_SITE_URL
    }, [])
    return (
        <div className='redirect'>

        </div>
    );
}

export default Redirect